import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import HoverIcon from './HoverIcon';
import withCloseOnOuterClick from '../../common/HOCs/withCloseOnOuterClick';
import LoadingSpinner from '../../common/loadingspinner/LoadingSpinner';

const ContextModalEntry = ({
    option, row, close, styles
}) => (
    <a href={ option.link } className={ styles['context-modal-link'] }>
        <div
            role="none"
            className={ classnames({
                [styles['context-modal-entry']]: true,
                [styles.disabled]: option.disabled
            }) }
            onClick={ (e) => {
                close(e);
                if (option.onClick) option.onClick(row);
            } }
        >
            <div className={ styles['context-modal-icon'] }>
                { option.loading
                    ? <LoadingSpinner styles={ styles } />
                    : <HoverIcon icon={ option.icon } hoverIcon={ option.hoverIcon } styles={ styles } /> }
            </div>
            <div className={ styles['context-modal-text'] }>{ option.label }</div>
        </div>
    </a>
);

ContextModalEntry.propTypes = {
    option: PropTypes.shape({
        icon: PropTypes.string.isRequired,
        hoverIcon: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired,
        loading: PropTypes.bool,
        disabled: PropTypes.bool,
        link: PropTypes.string
    }).isRequired,
    row: PropTypes.shape({}).isRequired,
    close: PropTypes.func.isRequired,
    styles: PropTypes.shape({
        'context-modal-link': PropTypes.string,
        'context-modal-entry': PropTypes.string,
        disabled: PropTypes.string,
        'context-modal-icon': PropTypes.string,
        'context-modal-text': PropTypes.string
    }).isRequired,
};

const ContextModal = withCloseOnOuterClick(({
    options, row, inputRef, closeControl, styles, xOffset, yOffset
}) => (
    <div ref={ inputRef }>
        <div className={ styles['context-modal'] } style={ { left: xOffset, top: yOffset } }>
            { options.map((option) => (
                <ContextModalEntry
                    key={ option.label }
                    option={ option }
                    row={ row }
                    close={ closeControl }
                    styles={ styles }
                />
            )) }
        </div>
    </div>
));

ContextModal.propTypes = {
    options: PropTypes.arrayOf(ContextModalEntry.propTypes.option),
    row: PropTypes.shape({}).isRequired,
    styles: PropTypes.shape({}).isRequired
};

export default ContextModal;
